<template>
    <div id="footer">
        <section class="hero is-medium">
            <div class="hero-body">
                <div class="container">
                    <div class="iframe-container" style="overflow: hidden;padding-top: 56.25%;position: relative;">
                        <iframe style="border: 0;height: 100%;left: 0;top: 0;right:0;bottom:0;position: absolute;width: 100%;" loading="lazy" src="https://cdn.forms-content.sg-form.com/8433b737-3b62-11ea-b146-f235d932819b" onload=""></iframe>
                        </div>

                    <div class="columns">
                        <div class="column is-5">
                            <div class="columns">
                                <div class="column">
                                    <h1 class="title">
                                        {{$t('InterestedTitle')}}
                                    </h1>
                                    <p>
                                        {{$t('InterestedText')}}
                                    </p>
                                </div> 
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <div class="columns">
                                        <div class="column">
                                            <h1 class="title">
                                                {{$t('DownloadNow')}}
                                            </h1>
                                        </div>
                                    </div>
                                    <div class="columns">
                                        <div class="column is-4">
                                            <a href="https://apps.apple.com/nl/app/horse-traq/id1482126463" traget="_blank">
                                                <img :src="$t('AppStoreButton')" style="height: 40px;">
                                            </a>
                                        </div>
                                        <div class="column is-4">
                                            <a href="https://play.google.com/store/apps/details?id=nl.HorseTraq" traget="_blank">
                                                <img :src="$t('PlayStoreButton')" style="height: 40px;">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <p>
                                        {{$t('AreYouAVeterinarian')}} 
                                        {{$t('ContactUsMail')}} <a href="mailto:accounts@horsetraq.app">accounts@horsetraq.app</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="column is-5 is-offset-2">
                            <div class="columns">
                                <div class="column">
                                    <h1 class="title">
                                        {{$t('KnowMore')}}
                                    </h1>
                                    <p>
                                        {{$t('ContactUs')}}
                                    </p>
                                </div>
                            </div>
                            <div class="columns contact">
                                <div class="column">
                                    <div class="columns">
                                        <div class="column is-2 has-text-centered">
                                            <a href="mailto:info@horsetraq.app">
                                                <img src="../assets/images/footer/envelope.svg" >
                                            </a>
                                        </div>
                                        <div class="column is-10 has-text-centered-mobile">
                                            <a href="mailto:info@horsetraq.app">info@horsetraq.app</a>
                                        </div>
                                    </div>
                                    <div class="columns">
                                        <div class="column is-2 has-text-centered">
                                            <a href="https://www.facebook.com/HORSE-TRAQ-115090826540917/" target="_blank">
                                                <img src="../assets/images/footer/facebook-logo.svg" >
                                            </a>
                                        </div>
                                        <div class="column is-10 has-text-centered-mobile">
                                            <a href="https://www.facebook.com/HORSE-TRAQ-115090826540917/" target="_blank">Horse Traq</a>
                                        </div>
                                    </div>
                                    <div class="columns">
                                        <div class="column is-2 has-text-centered">
                                            <a href="https://instagram.com/horsetraq" target="_blank">
                                                <img src="../assets/images/footer/instagram-logo.svg" >
                                            </a>
                                        </div>
                                        <div class="column is-10 has-text-centered-mobile">
                                            <a href="https://instagram.com/horsetraq" target="_blank">Horse Traq</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns documents">
                        <div class="column is-3">
                            
                            <a href="assets/docs/Nederland_ICT_Voorwaarden.pdf">{{$t('TermsAndConditions')}}</a>
                        </div>
                        <div class="column is-2">
                            <a href="assets/docs/Privacy_Policy_HorseTraq_v0.1.pdf">{{$t('PrivacyPolicy')}}</a>
                        </div>                        
                    </div>
                </div>
            </div>
            
        </section>

    </div>
</template>

<script>
export default {
  name: 'Footer',

}
</script>

